import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { FileInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerAddWorkOrderChangeFromXmlGql } from '../../WorkOrderChangeQueries';

interface IUseUerAddWorkOrderChangeFromXml {
    workOrderChangeId: any;
    onSuccess: () => void;
}

const requestId = 'uerAddWorkOrderChangeFromXml';

export const useUerAddWorkOrderChangeFromXml = (props: IUseUerAddWorkOrderChangeFromXml) => {
    const dispatch = useDispatch();
    const { onSuccess, workOrderChangeId } = props;

    const [uerAddWorkOrderChangeFromXmlReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerAddWorkOrderChangeFromXmlReset(undefined);
        onSuccess?.();
    }, [uerAddWorkOrderChangeFromXmlReset, onSuccess]);

    const [, uerAddWorkOrderChangeFromXmlStatus, , uerAddWorkOrderChangeFromXmlRequest] = useRequest({
        requestId,
        query: uerAddWorkOrderChangeFromXmlGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerAddWorkOrderChangeFromXmlMakeRequest = useCallback(
        (constructionTypeId: number, contractSeasonId: number, filesContent: FileInput[]) => {
            dispatch(
                uerAddWorkOrderChangeFromXmlRequest({
                    constructionTypeId,
                    contractSeasonId,
                    workOrderChangeId,
                    filesContent,
                }),
            );
        },
        [dispatch, uerAddWorkOrderChangeFromXmlRequest, workOrderChangeId],
    );

    useEffect(() => {
        uerAddWorkOrderChangeFromXmlReset(undefined);
    }, [uerAddWorkOrderChangeFromXmlReset]);

    return {
        status: uerAddWorkOrderChangeFromXmlStatus,
        makeRequest: uerAddWorkOrderChangeFromXmlMakeRequest,
    };
};
